class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();

      // Set flag in sessionStorage if item is a gift product 
      if (this.dataset.autoAdd && this.dataset.autoAdd == "true") {
        sessionStorage.setItem("gift-product-refused", "true");
      }

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    this.checkDiscountCodeInCookies();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }    
  
  
  addToCart(data) {
    return new Promise((resolve, reject) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(res => res.text())
        .then((state) => {
          this.replaceSections(state);
          document.dispatchEvent(new Event('onQuantityChange'));
          resolve();
        })
        .catch(err => {
          console.error(err);
          reject();
        })
    });
  }

  onLoad() {
    this.addMissingPictures().then(() => {
      const cartItems = Array.from(this.querySelectorAll('[id*="CartItem-"]'))
      const pictureIds = [...new Set(cartItems.filter(elem => elem.dataset.pictureId).map(elem => elem.dataset.pictureId))];
      pictureIds.forEach(id => {
        const pictureItem = document.querySelector(`[data-product-id="${id}"]`);

        if (pictureItem) {
          const currentQuantity = parseInt(pictureItem.querySelector('[name="updates[]"]').value);

          const futureProductCount = Array.from(this.querySelectorAll(`[data-picture-id="${id}"] [name="updates[]"]`))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

          if (futureProductCount != currentQuantity) {
            this.updateQuantity(pictureItem.dataset.line, futureProductCount, "updates[]");
          }
        }
      })
    });
  }

  addMissingPictures() {
    const cartItems = Array.from(this.querySelectorAll('[id*="CartItem-"]'))
    const pictureIds = [...new Set(cartItems.filter(elem => elem.dataset.pictureId).map(elem => elem.dataset.pictureId))];
    const missingPictures = pictureIds.filter(id => !(document.querySelector(`[data-product-id="${id}"]`)));

    if (missingPictures.length > 0) {
      const items = missingPictures.map(elem => {
        return { id: elem, quantity: 1 };
      });
      const data = {
        items: items,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
      return this.addToCart(data);
    } else {
      return Promise.resolve();
    }
  }

  // This is also triggered when a packaging option is selected. updateQuantity is not needed in this case
  onChange(event) {
    if (event.target.dataset.index && event.target.value) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-packaging-options-selector',
        section: document.getElementById('cart-packaging-options-selector')?.dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  async updateQuantity(line, quantity, name, variantId) {
      const cartItem = this.querySelector(`#CartItem-${line}`);
      const updatedItems = {};
      updatedItems[cartItem.dataset.lineItemKey] = Number(quantity);


      // Update related motiv quantity
      const cart = await this.fetchCart();
      const motiveRef = cart.items.find(el => el.properties?._is_related_cover === "true" && el.properties?._parent_key == cartItem.dataset.lineItemKey);
      if (motiveRef) {
        updatedItems[motiveRef.key] = Number(quantity);
      } 
    
      this.enableLoading(line);

      const body = JSON.stringify({
        updates: updatedItems,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
    
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        document.dispatchEvent(new Event('onItemDeleted'));
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  replaceSections(state) {
    const parsedState = JSON.parse(state);
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter)
      cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
    return parsedState;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  async checkDiscountCodeInCookies() {
    // Check if user refused and removed the gift product from cart
    const giftProductRefused = !!(sessionStorage.getItem("gift-product-refused") && (sessionStorage.getItem("gift-product-refused") == "true"));
    const discountCode = this.getCookie("discount_code");
    const discountVariantMappings = JSON.parse(document.querySelector("[discount-variant-mappings]")?.innerText || "[]");
    
    if (discountCode) {
      const discountVariantItem = discountVariantMappings.find(el => discountCode.startsWith(el.discount_code_prefix));
      if (discountVariantItem) {
        const variantID = Number(discountVariantItem?.variant_id);

        if (!giftProductRefused) {
          const isExistInCart = await this.isItemInCart(variantID);
          if (!isExistInCart) {
            this.addToCart({
              items: [{ id: variantID, quantity: 1, properties: { _auto_add: "true"}}],
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname
            });
          }
        } 
      }
    }
  }

  async isItemInCart(productID) {
    const response = await fetch("/cart.json");
    const cart = await response.json();
    const isExistInCart = cart.items.find(el => el.id == productID);
    return isExistInCart;
  }

  addGiftProduct(gift_product) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(gift_product)
    })
      .then(res => res.json())
      .then(data => {
        window.location.reload();
      })
      .catch(err => {
        console.error(err);
      });
  }

  getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return null;
  }

  async fetchCart() {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error('An error occurred while fetching the cart');
      const cart = await response.json();
      return cart;  
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}